module.exports = __webpack_public_path__ + "static/28-2001067b35a5f4bc3731af94cea36fb2.gif";